module.exports = __webpack_public_path__ + "react/sources/images/just-ask-aiden.svg";